import { useLocation, useNavigate } from "react-router";
import { useSession } from "../lib/session.js";
import { Mark } from "../components/icons.js";
import { Button } from "../components/ui.js";

/** First screen after login on a new device, and the way to switch branches later. */
export function BranchSelectPage() {
  const { me, setBranchId, logout } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  if (!me) return null;
  const from = (location.state as { from?: string } | null)?.from ?? "/";

  return (
    <div className="screen-center brand">
      <div className="stack-lg" style={{ width: "min(880px, 100%)", display: "grid", gap: 28 }}>
        <div className="row" style={{ gap: 14 }}>
          <Mark style={{ width: 26, height: 36, color: "var(--brand-light)" }} />
          <div>
            <div className="kicker" style={{ color: "rgba(255,255,255,.6)" }}>
              {me.tenant.name}
            </div>
            <h1 className="h1" style={{ fontSize: "2.25rem" }}>
              ¿En qué sucursal estás, {me.user.full_name.split(" ")[0]}?
            </h1>
          </div>
        </div>
        <div className="branch-grid">
          {me.branches
            .filter((b) => b.is_active)
            .map((b) => (
              <button
                key={b.id}
                type="button"
                className="branch-card"
                onClick={() => {
                  setBranchId(b.id);
                  navigate(from === "/sucursal" || from === "/" ? "/inicio" : from, { replace: true });
                }}
              >
                <span className="code">{b.short_code}</span>
                <span className="name">{b.name}</span>
                {b.address && <span className="addr">{b.address}</span>}
              </button>
            ))}
        </div>
        <div>
          <Button variant="ghost" icon="logout" onClick={() => void logout()} style={{ color: "rgba(255,255,255,.7)" }}>
            Cerrar sesión
          </Button>
        </div>
      </div>
    </div>
  );
}
